import React, { useEffect, useState } from 'react';
import {
  Autocomplete,
  Button,
  Dialog,
  DialogContent,
  InputAdornment,
  MenuItem,
  Paper,
  Popper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import userProfile from '../../../../assets/images/userProfile.svg';
import InviteMember from '../../../../assets/images/InviteMember.svg';
import { ReactComponent as SearchIcon } from '../../../../assets/images/Search.svg';
import { useHook as equipmentHook } from '../useHook';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { parseJSON } from 'date-fns/fp';
import { Popup, Pagination, Unauthorized } from '../../../../components/index';

const SharedEquipment = () => {
  const {
    fetchCustomerName,
    shareEquipment,
    updateshareEquipment,
    fetchEquipmentShareList,
    deleteShareEquipment,
  } = equipmentHook();
  const { id } = useParams();
  const { inviteMemberList } = useSelector((state: any) => state.equipmetInfo);
  const [inviteOpen, setInviteOpen] = useState(false);
  const [forms, setForms] = useState<any>([
    // { countryCode: '+91', mobileNo: '', permission: 'READ' },
  ]);
  const [deletePopup, setDeletePopup] = useState(false);
  const [deleteId, setDeleteId] = useState<string | number>('');
  const [errorMessage, setErrorMessage] = useState('');
  const [sharedMemberData, setSharedMemberData] = useState<any>([]);
  const [activeMemberData, setActiveMemberData] = useState(false);
  const [inviteEditOpen, setInviteEditOpen] = useState<any>({
    open: false,
    editData: {},
  });
  const [editDataPermission, setEditDataPermission] = useState('');
  const [activeEditButton, setActiveEditButton] = useState(false);
  const [optionMemberData, setOptionMemberData] = useState<any>([]);
  const [formFieldData, setFormFieldData] = useState<any>({
    countryCode: '+91',
    mobileNo: '',
    permission: 'READ',
  });
  const handleCLoseEdit = () => {
    setEditDataPermission('');
    setInviteEditOpen({ open: false, editData: {} });
    setActiveEditButton(false);
    setErrorMessage('');
  };

  const sharedEquipment = async (editPayload?: any) => {
    const payload: any = { unitID: id, permissions: {} };

    if (editPayload) {
      payload.permissions[editPayload.cusotmerID] = editDataPermission;
      try {
        await updateshareEquipment(payload).then((res) => {
          if (res) {
            getEquipmentList();
          }
        });
      } catch (error) {
        console.log(error, 'error');
      } finally {
        handleCloseInvite();
        handleCLoseEdit();
      }
    } else {
      for (const data of sharedMemberData || []) {
        payload.permissions[data?.customerID] = data?.permission;
      }
      try {
        await shareEquipment(payload).then((res) => {
          if (res) {
            getEquipmentList();
          }
        });
      } catch (error) {
        console.log(error, 'error');
      } finally {
        handleCloseInvite();
        handleCLoseEdit();
      }
    }
  };

  const getInviteMemberData = async (formData: any) => {
    const payload = {
      mobileNo: formData?.mobileNo?.toString(),
    };
    await fetchCustomerName(payload).then((response: any) => {
      if (response) {
        setSharedMemberData((pre: any) => [
          ...pre,
          { ...response, ...formData },
        ]);
      }
    });
  };

  const getMemberName = async (mobile: any) => {
    const payload = {
      mobileNo: mobile?.toString(),
    };
    await fetchCustomerName(payload).then((response: any) => {
      if (response && Object.keys(response).length > 0) {
        const newOption = { ...response, label: mobile?.toString() };
        const updateOptions = [...optionMemberData, newOption];
        const uniqueCustomers = updateOptions.filter(
          (customer: { customerID: any }, index: any, self: any[]) =>
            index ===
            self.findIndex((c) => c.customerID === customer.customerID),
        );
        setOptionMemberData(uniqueCustomers);
      }
    });
  };
  useEffect(() => {
    if (sharedMemberData?.length > 0 && activeMemberData) {
      sharedEquipment();
    }
  }, [sharedMemberData, activeMemberData]);

  useEffect(() => {
    getEquipmentList();
  }, [id]);

  //get EquipmentList
  const getEquipmentList = async () => {
    await fetchEquipmentShareList({ unitID: id });
  };
  const isFormValid = () => {
    return forms.every((form: any) => form?.mobileNo?.length === 10);
  };

  //add more
  // const addForm = () => {
  //   if (isFormValid() && forms?.length < 10) {
  //     setForms([
  //       ...forms,
  //       { countryCode: '+91', mobileNo: '', permission: 'READ' },
  //     ]);
  //     setErrorMessage('');
  //   } else {
  //     setErrorMessage(
  //       'Please enter a valid 10-digit mobile number before adding more inputs.',
  //     );
  //   }
  // };

  //mobile select
  const handleSelectMobile = (value: any) => {
    // const updateForm = forms?.map((formData: any, i: number) =>
    //   i === index ? { ...formData, mobileNo: value?.label } : formData,
    // );
    if (value?.label) {
      const removeDublicate = forms?.filter(
        (data: { mobileNo: any }) => data?.mobileNo !== value?.label,
      );
      setForms(() => [
        ...removeDublicate,
        {
          countryCode: formFieldData?.countryCode,
          mobileNo: value?.label,
          permission: formFieldData?.permission,
        },
      ]);
      setFormFieldData({
        countryCode: '+91',
        mobileNo: '',
        permission: 'READ',
        inputValue: '',
      });
    }
    // if (value && value.length === 10) {
    //   setErrorMessage(''); // Clear error message when the input is valid
    // }
    // const updateForm = forms?.map((formData: any, i: number) =>
    //   i === index ? { ...formData, mobileNo: value } : formData,
    // );
    // setForms(updateForm);
  };

  const handleInputValueChange = (newValue: string) => {
    // const updatedForms = [...forms];
    // updatedForms[index].inputValue = newValue; // Update the specific inputValue
    // setForms(updatedForms);
    setFormFieldData((prev: any) => ({
      ...prev,
      inputValue: newValue,
    }));
    if (newValue?.length === 10) {
      const findOptionMobile = optionMemberData?.filter(
        (obtions: { label: string }) => obtions?.label === newValue,
      );
      if (!findOptionMobile || findOptionMobile?.length === 0) {
        getMemberName(newValue);
      }
    }
  };

  //permission select
  const handleChangePermission = (value: any) => {
    // const updateForm = forms?.map((formData: any, i: number) =>
    //   i === index ? { ...formData, permission: value } : formData,
    // );
    // setForms(updateForm);
    setFormFieldData((prev: any) => ({
      ...prev,
      permission: value,
    }));
  };

  //close invite popup
  const handleCloseInvite = () => {
    setActiveMemberData(false);
    setInviteOpen(false);
    setForms([]);
    setSharedMemberData([]);
    setErrorMessage('');
  };

  //open invite popup
  const handleOpenInvite = () => {
    setInviteOpen(true);
  };
  const memberData = [
    { name: 'The Shawshank Redemption', label: '9798989811' },
    { name: 'The Godfather', label: '9798989898' },
  ];
  const CustomPopper = (props: any) => {
    return <Popper {...props} className="custom_popper" />; // Set the desired width
  };

  const submitShareEquipment = async () => {
    if (isFormValid()) {
      const promises = forms.map(async (formData: any) => {
        await getInviteMemberData(formData);
      });

      await Promise.all(promises); // Wait for all promises to resolve
      setActiveMemberData(true);
    } else {
      setErrorMessage(
        'Please enter a valid 10-digit mobile number before adding more inputs.',
      );
    }
  };

  const handleDelete = () => {
    const payload = {
      unitID: id,
      customerID: deleteId,
    };
    deleteShareEquipment(payload)
      .then((res) => {
        setDeletePopup(false);
        getEquipmentList();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleRemoveFormData = (removeData: any) => {
    const updatedForms = forms?.filter(
      (data: any) =>
        !(
          data?.countryCode === removeData?.countryCode &&
          data?.mobileNo === removeData?.mobileNo &&
          data?.permission === removeData?.permission
        ),
    );

    setForms(updatedForms);
  };
  return (
    <>
      <section className="share_equipment-header">
        <div>
          <h4>Members</h4>
          <p>Manage user within your organization</p>
        </div>
        <Button onClick={handleOpenInvite}>
          <img src={InviteMember} width="19" height="19" alt="shareIcon" />
          Invite Member{' '}
        </Button>
      </section>
      <TableContainer className="controller_table" component={Paper}>
        <Table>
          <TableHead className="controller_tableheader">
            <TableRow>
              <TableCell>Names</TableCell>
              <TableCell>Number</TableCell>
              <TableCell className="equipment_action_coloumn"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!inviteMemberList || inviteMemberList?.length === 0 ? (
              <TableRow>
                <TableCell colSpan={2}>
                  <Typography variant="body1" align="left">
                    No Data found
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              inviteMemberList?.map((member: any, index: number) => (
                <TableRow key={index}>
                  <TableCell>
                    <div
                      className="controller_management_name-data  "
                      //   onClick={() =>
                      //     navigate(
                      //       `/equipment/sharedwithmeequipment/details/${equipment?.equipmentName || ' '}/${equipment?.unitID}`,
                      //     )
                      //   }
                    >
                      <img
                        src={member?.image ? member?.image : userProfile}
                        width={40}
                        alt="User Profile"
                      />{' '}
                      <p>{member?.name}</p>
                    </div>
                  </TableCell>

                  <TableCell>
                    <div className="controller_management_model-data">
                      <p>{member?.mobileNo}</p>
                    </div>
                  </TableCell>
                  <TableCell>
                    <div className="form-action-btn">
                      <Button
                        className="btn-transparent border-0 img-background-form"
                        onClick={() => {
                          setInviteEditOpen({ open: true, editData: member });
                          setEditDataPermission(member?.permission);
                        }}
                        // onClick={() =>
                        //   navigate(
                        //     `/hardware/equipments/edit/${equipment?.equipmentName ? equipment?.equipmentName : ' '}/${equipment.equipmentID}`,
                        //   )
                        // }
                      >
                        <i className="edit-icon bi bi-pencil-square bi-lg"></i>
                      </Button>
                      <Button
                        className="btn-transparent border-0 img-background-form"
                        onClick={() => {
                          setDeleteId(
                            member.cusotmerID ? member.cusotmerID : '',
                          );
                          setDeletePopup(true);
                        }}
                      >
                        <i className="delete-icon bi bi-trash3-fill bi-lg"></i>
                      </Button>
                    </div>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* <Pagination
        rowsPerPageOptions={[5, 10, 20, 30]}
        currentPage={currentPage}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
        totalPages={totalPages}
      /> */}

      <Dialog
        open={inviteOpen}
        onClose={handleCloseInvite}
        className="invitemember_popup"
      >
        <DialogContent>
          <section>
            <header className="invitemember_popup-header">
              <h4>Invite A member</h4>
              <p>Add a user to your organization</p>
            </header>
            <section className="invitemember_popup-content">
              <h5>Enter contact number</h5>

              {/* {forms?.map((data: any, index: number) => ( */}
              <div className="invitemember_popup-content-mobile">
                <Select
                  className="form-countrycode"
                  variant="outlined"
                  // error={errors.countrycode ? true : false}
                  // onChange={handleCountryCodeChange}
                  defaultValue="+91"
                >
                  <MenuItem value="+91">+91</MenuItem>
                </Select>
                <div className="invitemember_popup-content-mobile-dropdown">
                  {/* <TextField
                      className="form-mobile"
                      fullWidth
                      value={data?.mobileNo}
                      inputProps={{
                        maxLength: 10,
                      }}
                      onChange={(e) => {
                        const sanitizedValue = e.target.value.replace(
                          /\D/g,
                          '',
                        );
                        handleSelectMobile(sanitizedValue, index);
                      }}
                      variant="outlined"
                    /> */}
                  <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    options={optionMemberData}
                    fullWidth
                    value={formFieldData?.mobileNo}
                    onChange={(event, newValue) => handleSelectMobile(newValue)}
                    inputValue={formFieldData?.inputValue}
                    onInputChange={(event, newInputValue) => {
                      const sanitizedValue = newInputValue.replace(/\D/g, '');
                      if (sanitizedValue?.length <= 10) {
                        handleInputValueChange(sanitizedValue);
                      }
                    }}
                    PopperComponent={CustomPopper} // Use the custom Popper
                    sx={{
                      '& .MuiAutocomplete-endAdornment': {
                        display: 'none', // Hide the arrow icon
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        inputProps={{
                          ...params.inputProps,
                          onKeyPress: (event) => {
                            if (!/[0-9]/.test(event.key)) {
                              event.preventDefault();
                            }
                          },
                          maxLength: 10, // Ensure the input length is capped at 10
                        }}
                      />
                    )}
                    renderOption={(props, option) => (
                      <li {...props} className="contact_number_option">
                        <div className="contact_number_option-profile">
                          <img src={userProfile} alt="profile" />
                          <p>{option.name}</p>
                        </div>
                        <p>{option.label}</p>
                      </li>
                    )}
                  />
                  <div className="invitemember_popup_line"></div>
                  <Select
                    value={formFieldData?.permission}
                    onChange={(e) => handleChangePermission(e.target.value)}
                    defaultValue={formFieldData?.permission || 'READ'}
                    style={{ minWidth: 100 }} // Adjust the width as needed
                  >
                    <MenuItem value="READ">READ</MenuItem>
                    <MenuItem value="WRITE">WRITE</MenuItem>
                  </Select>
                </div>
              </div>
              {/* ))} */}
              {errorMessage && (
                <p style={{ color: 'red', marginTop: '10px' }}>
                  {errorMessage}
                </p>
              )}

              {forms?.length > 0 && (
                <section className="sharedequipment_form_table">
                  <TableContainer
                    className="controller_table"
                    component={Paper}
                  >
                    <Table>
                      <TableHead className="controller_tableheader">
                        <TableRow>
                          <TableCell>County Code</TableCell>
                          <TableCell>Mobile Number</TableCell>
                          <TableCell>Role</TableCell>
                          <TableCell></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {forms?.map((data: any, index: any) => (
                          <TableRow key={index}>
                            <TableCell>
                              <p className="controller_management_model-data">
                                {data?.countryCode}
                              </p>
                            </TableCell>

                            <TableCell>
                              <p className="controller_management_model-data">
                                {data?.mobileNo}
                              </p>
                            </TableCell>

                            <TableCell>
                              <p className="controller_management_model-data">
                                {data?.permission}
                              </p>
                            </TableCell>

                            <TableCell className="controller_management_icons-data">
                              <div className="form-action-btn">
                                <Button
                                  className="btn-transparent border-0 img-background-form"
                                  onClick={() => handleRemoveFormData(data)}
                                >
                                  <i className="delete-icon bi bi-trash3-fill bi-lg"></i>
                                </Button>
                              </div>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </section>
              )}

              <Button
                className={
                  forms.length >= 10
                    ? 'invitemember_popup-content-addmore-hidde'
                    : 'invitemember_popup-content-addmore-hidde'
                }
                // onClick={addForm}
              >
                + Add More
              </Button>
              <div className="invitemember_popup-footer">
                <Button
                  className="invitemember_popup-footer-cancel"
                  onClick={handleCloseInvite}
                >
                  Cancel
                </Button>
                <Button
                  className={
                    forms?.length === 0 || forms?.length > 10
                      ? 'invitemember_popup-footer-share disable_button_background'
                      : 'invitemember_popup-footer-share'
                  }
                  onClick={submitShareEquipment}
                  disabled={forms?.length === 0 || forms?.length > 10}
                >
                  Share
                </Button>
              </div>
            </section>
          </section>
        </DialogContent>
      </Dialog>

      {deletePopup && (
        <Popup
          open={deletePopup}
          handleClose={() => {
            setDeletePopup(false);
          }}
          handleDelete={() => {
            handleDelete();
          }}
          page="role"
        />
      )}

      <Dialog
        open={inviteEditOpen?.open}
        onClose={handleCLoseEdit}
        className="invitemember_popup"
      >
        <DialogContent>
          <section>
            <header className="invitemember_popup-header">
              <h4>{inviteEditOpen?.editData?.name || ''}</h4>
            </header>
            <section className="invitemember_popup-content">
              <h5>Permission</h5>
              <div className="invitemember_popup-content-mobile">
                <Select
                  fullWidth
                  value={editDataPermission}
                  onChange={(e) => {
                    setEditDataPermission(e.target.value);
                    setActiveEditButton(true);
                  }}
                  style={{ minWidth: 100 }} // Adjust the width as needed
                >
                  <MenuItem value="READ">READ</MenuItem>
                  <MenuItem value="WRITE">WRITE</MenuItem>
                </Select>
              </div>
              <div className="invitemember_popup-footer editmember_popup-footer">
                <Button
                  className="invitemember_popup-footer-cancel"
                  onClick={handleCLoseEdit}
                >
                  Cancel
                </Button>
                <Button
                  className={
                    activeEditButton
                      ? 'invitemember_popup-footer-share'
                      : 'invitemember_popup-footer-share disable_button_background'
                  }
                  onClick={() => sharedEquipment(inviteEditOpen?.editData)}
                  disabled={!activeEditButton}
                >
                  Update
                </Button>
              </div>
            </section>
          </section>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default SharedEquipment;
